import {FC, useState} from 'react'
import {useDispatch} from 'react-redux'
import {hideLoader} from 'app/redux/loaderSlice'
import clsx from 'clsx'
import CustomButton from 'app/features/orders/componentsv1/edit/customer/CustomButton'
import {PaymentMethod} from 'app/features/orders/componentsv1/shared/customer'
import CustomerPaymentDialog from './CustomerPaymentDialog'

interface Props {
  title: string
  isEditMode: boolean
  paymentMethod: any
  customerId: string
  onChangePaymentMethod?: (pm: any) => void | any
  isEditOrder?: boolean
  isPaymentSubmitting?: boolean
}

export const PaymentAction: FC<Props> = ({
  title,
  isEditMode,
  paymentMethod,
  customerId,
  onChangePaymentMethod,
  isEditOrder,
  isPaymentSubmitting,
}) => {
  const dispatch = useDispatch()
  const [showADialog, setShowDialog] = useState(false)

  const handleOpenDialog = () => {
    setShowDialog(true)
  }

  const handleClose = () => {
    dispatch(hideLoader())
    setShowDialog(false)
  }

  const handlePaymentChange = async (payment: any) => {
    try {
      if (isEditOrder && onChangePaymentMethod) {
        if (await onChangePaymentMethod(payment)) {
          handleClose()
        }
      } else {
        if (onChangePaymentMethod) {
          await onChangePaymentMethod(payment)
        }
        handleClose()
      }
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <div className='d-flex flex-column'>
      <div
        className={clsx(
          'd-flex align-items-center fs-5 fw-bolder justify-content-between',
          !isEditMode && 'mb-2 pt-2'
        )}
      >
        {title}
        {isEditMode && (
          <CustomButton onClick={handleOpenDialog}>
            {paymentMethod && paymentMethod.id ? 'Change' : 'Create'}
          </CustomButton>
        )}
      </div>
      <PaymentMethod paymentMethod={paymentMethod} />
      {showADialog && (
        <CustomerPaymentDialog
          onClose={handleClose}
          customerId={customerId}
          selectedPayment={paymentMethod.id}
          onChangePaymentMethod={handlePaymentChange}
          isSubmitting={isPaymentSubmitting}
        />
      )}
    </div>
  )
}

export default PaymentAction
